import { CircleNotchIcon, MapPinIcon } from "@phosphor-icons/react";

interface OnboardingCityRowProps {
  name: string;
  /** Second line, e.g. "United Kingdom • 1,600 places". */
  subtitle: string;
  /** Orange for a city we cover, grey for one that needs contributions. */
  pin: "orange" | "grey";
  /** True while the click is being resolved to coordinates. */
  isSelecting?: boolean;
  onSelect: () => void;
}

/**
 * City result row inside the search list (Figma "Menu list item/Large-48").
 * The row draws no border of its own — the list owns the frame and dividers.
 */
const OnboardingCityRow = ({
  name,
  subtitle,
  pin,
  isSelecting = false,
  onSelect,
}: OnboardingCityRowProps) => (
  <button
    type="button"
    onClick={onSelect}
    disabled={isSelecting}
    aria-busy={isSelecting}
    // The bullet is a visual separator; spoken it is noise, so the accessible
    // name uses a comma instead.
    aria-label={`${name}, ${subtitle.replace(" • ", ", ")}`}
    className="focus-blue flex min-h-[48px] w-full items-center gap-2 px-4 py-3 text-left transition-colors hover:bg-bg-brand-secondary-hover disabled:opacity-60"
  >
    <MapPinIcon
      size={24}
      weight="fill"
      aria-hidden="true"
      className={pin === "orange" ? "text-pin-orange" : "text-pin-grey"}
    />

    <span aria-hidden="true" className="min-w-0 flex-1 px-1">
      <span className="body-base-medium block truncate text-fg-neutral-strong">
        {name}
      </span>
      <span className="body-s-regular block truncate text-fg-neutral-subtle">
        {subtitle}
      </span>
    </span>

    {isSelecting ? (
      <CircleNotchIcon
        size={20}
        aria-hidden="true"
        className="shrink-0 animate-spin text-fg-brand-strong"
      />
    ) : null}
  </button>
);

export default OnboardingCityRow;
